import { convertTimetoString } from "../../../helperFunction";
import css from "../Approvals/css/view-modal.module.css";
import styled from "@emotion/styled";
import DocumentBar from "./DocumentBar";
import { useState, useContext } from "react";
import { NotificationContext } from "../../../providers/notification";
import { ApplicationsContext } from "../Applications/Applications";
import apiCall from "../../../utils/apiCall";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { NotAvailable } from "./styles";
import { HRStrategiesProps, HRStrategiesDetails } from "./type";
import styles from "./css/styles.module.css";

interface Payload {
  id?: number;
  applicantId?: string;
  qualificationId?: number;
  score: number;
}

const HrStrategies: React.FC<HRStrategiesProps> = ({
  data = [],
  handleCancel,
  routeId,
}) => {
  const [score, setScore] = useState("");
  const [showHrStrategic, setShowHrStrategic] = useState(false);
  const [id, setId] = useState<number | undefined>(0);
  const [applicantId, setApplicantId] = useState<string | undefined>("");
  const { showNotification } = useContext(NotificationContext);
  const { isApplicationMenu } = useContext(ApplicationsContext);

  const queryClient = useQueryClient();

  const showScoresUpdate = isApplicationMenu ? false : true;

  const filterHrStrategic = data.filter(
    (item) => item?.IsResearch === (false || null)
  );

  const handleScore = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScore(event.target.value);
  };

  const url = `/Applicant/UpdateHRStrategyScoreByApplicantId?id=${id}&applicantId=${applicantId}&score=${Number(
    score
  )}`;

  const updateHrStrategic = async (data: Payload) => {
    return await apiCall().post(url, data);
  };

  const updateHrStrategicMutation = useMutation(
    ["update-HrStrategicScore"],
    updateHrStrategic,
    { retry: 0 }
  );

  const updateHrTrainingScoreHandler = async () => {
    const payload: Payload = {
      id: id,
      applicantId: applicantId,
      score: Number(score),
    };

    try {
      await updateHrStrategicMutation.mutateAsync(payload, {
        onSuccess: () => {
          showNotification({
            type: "success",
            message: "HR Strategies Score has been successfully updated",
          });

          queryClient.refetchQueries(["get-hrStrategies-details", applicantId]);
          queryClient.refetchQueries(["get-all-personal-details"]);
          queryClient.refetchQueries(["get-approval"]);

          setScore("");
          setShowHrStrategic(false);
        },
      });
    } catch (error: any) {
      showNotification({
        type: "error",
        message: error?.response?.data?.Message || error?.message,
      });
    }
  };

  const handleHrStrategic = (data?: HRStrategiesDetails) => {
    setShowHrStrategic(!showHrStrategic);
    setId(data?.Id);
    setApplicantId(data?.ApplicantId);
  };

  return (
    <div className={css.contentDiv}>
      <p className={css.title}>HR Strategic Project(s)</p>
      {filterHrStrategic?.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table>
            <tr className={styles.tableHead}>
              <th>Project Name</th>
              <th>Description</th>
              <th>Year</th>
              <th>Uploaded Document</th>
            </tr>
            {filterHrStrategic?.length > 0
              ? filterHrStrategic.map(
                  (eData: HRStrategiesDetails, index: number) => (
                    <tr key={index}>
                      <td>{eData?.ProjectName} </td>
                      <td>{eData?.Description} </td>
                      <td> {convertTimetoString(eData?.Year, 3)} </td>
                      <td>
                        <DocumentBar
                          hideScoreIntegration={showScoresUpdate}
                          docName={`HR STRATEGIES `}
                          documentUrl={eData?.ProjectURL}
                          onChange={handleScore}
                          handleVisibility={() => handleHrStrategic(eData)}
                          score={score}
                          displayScore={eData?.Score}
                          handleSubmit={updateHrTrainingScoreHandler}
                          loading={updateHrStrategicMutation.isLoading}
                        />
                      </td>
                    </tr>
                  )
                )
              : ""}
          </table>
        </div>
      ) : (
        <NotAvailable>Not Available</NotAvailable>
      )}
    </div>
  );
};

export default HrStrategies;